import Drawer from '@mui/material/Drawer';
import { useAtomValue } from 'jotai';
import { Typography } from '@mui/material';
import { selectedReport as selectedReportState } from '../../state';
import { Comments } from '@/components/shared/Comments';
import { abyssColors } from '@/theme/colors';
import { useDrawerWidths } from '@/hooks/useDrawerWidths';
import { useNavbarHeight } from '@/hooks/useNavbarHeight';

export const ReportComments = () => {
  const selectedReport = useAtomValue(selectedReportState);
  const { rightDrawerWidth } = useDrawerWidths();
  const navbarHeight = useNavbarHeight();

  return (
    <Drawer
      sx={{
        width: rightDrawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: rightDrawerWidth,
          boxSizing: 'border-box',
          position: 'absolute',
          height: `calc(100vh - ${navbarHeight}px)`,
          backgroundColor: abyssColors.primary[50],
        },
      }}
      variant="permanent"
      anchor="right"
    >
      {selectedReport?.id ? (
        <Comments referenceId={selectedReport.id} collectionName="reports" />
      ) : (
        <Typography variant="body1" data-testid="report-comment-placeholder">
          Select a report to see the comments
        </Typography>
      )}
    </Drawer>
  );
};
